//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CombinedPayBankList from "@/components//Repay/CombinedPayBankList";

export default {
    name: 'combinedPay',
    components: {
        CombinedPayBankList
    },
    props: {
        actualAmount: [Number, String],
        themeType: String,
        bankList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        vipVo: {
            type: Object,
        },
        isChooseGold: String,
    },
    data() {
        return {
            showPop: false,
        }
    },
    created() {

    },
    methods: {
        showPopup() {
            this.showPop = true;
            this.sensorsRecord("h5_clk", {
                tgt_event_id: 'h5_paycash_combindedrepay_show',
                tgt_name: 'h5-paycash-确认还款页-组合支付弹窗展示',
                url: location.href,
                page: '还款-确认还款页'
            });
        },
        closePopup() {
            this.showPop = false;
            this.sensorsRecord("h5_clk", {
                tgt_event_id: 'h5_paycash_combindedrepay_close',
                tgt_name: 'h5-paycash-确认还款页-组合支付弹窗不展示',
                url: location.href,
                page: '还款-确认还款页'
            });
        },
        repayApply(data) {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: 'h5_paycash_combindedrepay_apply',
                tgt_name: 'h5-paycash-确认还款页-组合支付还款申请',
                url: location.href,
                page: '还款-确认还款页',
                param4: data.repayApplyType,
            });
            this.$emit("repay-apply", data)
        }
    }
}
